import type { Guest, GuestStatus } from '../types/Guests';

/**
 * One meaning of "archived" for a guest: the API's archived flag, carried on
 * `Guest.archived`. `Guest.status` is a separate lifecycle field ('active' /
 * 'inactive') and is never 'archived' in the UI; a legacy 'archived' status
 * coming from the server is read as 'active'.
 */

/** True only when the server has the guest archived. */
export function isGuestArchived(guest: Pick<Guest, 'archived'> | null | undefined): boolean {
  return guest?.archived === true;
}

/** Permanent delete is only possible (and only offered) for a server-archived guest. */
export function canDeleteGuestPermanently(guest: Pick<Guest, 'archived'> | null | undefined): boolean {
  return isGuestArchived(guest);
}

/** The lifecycle status to show/store: never 'archived'. */
export function lifecycleStatus(status: string | null | undefined): GuestStatus {
  return status === 'inactive' ? 'inactive' : 'active';
}

/** The state shared with the header's Archive / Restore buttons. */
export function guestArchiveState(guest: Pick<Guest, 'archived'> | null | undefined): 'active' | 'archived' {
  return isGuestArchived(guest) ? 'archived' : 'active';
}
